













































































































































































































































































import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import {
  Getter,
} from 'vuex-class';
import AdminDeviceTypeService from '@/services/admin.devicetype.service';

@Component({
  components: {
  },
})
export default class ConfigurationProfiles extends Vue {

  @Prop() private deviceType: any;
  @Prop() private orgId!: number;
  @Prop() private source!: string;
  @Prop() private isAdminDeviceTypeSettings!: boolean;
  @Getter private hasPermission: any;

  private ready: boolean = false;
  private configError: string = '';
  private preventClose: boolean = false;

  private addingProfile: boolean = false;
  private isProfileView: boolean = true;
  private filteredFields: any[] = [];
  private newProfile: any = {};
  private configurationProfiles: any = [];
  private originalProfiles: any = {};
  private selectedProfile: any = {};
  private selectedProfileName: string | null = '';
  private selectedMessageType: any = {};
  private editing: boolean = false;
  private messageTypes: any = [];
  private configurationData: any = {};
  private deleted: any = {};

  @Watch('deviceType.configuration_profiles', {deep: true})
  public onChangeData(): void {
    this.setConfigurationData();
  }

  private save() {
    if (this.addingProfile) {
      this.createProfile();
    } else if (this.isProfileView) {
      this.getConfigFromVue();
    }
  }

  private async mounted() {
    await this.setConfigurationData();
    this.originalProfiles = this.deviceType.configuration_profiles;
  }

  private async setConfigurationData() {
    if (!this.deviceType.configuration_profiles) {
      if (this.deviceType.id) {
        const configProfiles = await AdminDeviceTypeService.getSystemConfigurationProfiles(this.deviceType.id);
        this.deviceType.configuration_profiles = configProfiles;
      }
    }

    const input = this.deviceType.configuration_profiles;

    if (input) {
      const filtered = input.filter((profile: any) => profile.organisation_id === null );
      Vue.set(this, 'configurationProfiles', filtered);
      this.getMessageTypes();

      this.ready = true;
      this.addingProfile = false;
      this.isProfileView = false;
    }
  }

  private getMessageTypes() {
    const output: any[] = [];
    const downlinks = this.deviceType.schema_fields.filter((schema: any) => schema.direction === 'downlink');

    downlinks.forEach((entry: any) => {
      if (entry.message_type) {
        output.push(entry.message_type);
      }
    });
    Vue.set(this, 'messageTypes', [...new Set(output)]);
  }

  // When you click Add Profile
  private addBlankConfiguration() {
    this.selectedMessageType = null;

    !this.addingProfile ?
      this.configurationData = this.selectedProfile :
      this.configurationData = this.newProfile;

    this.addingProfile = true;
    this.isProfileView = false;
    this.selectedProfileName = '';
    this.configError = '';
    const profile = {
      name: '',
      device_version_id: this.deviceType.id,
      global_default: false,
      configuration_profile_messages: [{
        message_type: undefined,
        configuration_profile_values: [],

      }],
    };

    Vue.set(this, 'newProfile', profile);
  }

  private filterForMessageType(msgType: any) {
    let input: any = [];
    let filtered: any = [];

    if (!this.addingProfile) {
      filtered = this.deviceType.schema_fields
        .filter((value: any) => value.message_type === msgType && value.direction === 'downlink');

      Vue.set(this, 'filteredFields', filtered);
    } else {
      if (typeof msgType === undefined) { msgType = this.messageTypes[0]; }
      input = this.newProfile;
      input.configuration_profile_messages[0].message_type = msgType;

      filtered = this.deviceType.schema_fields
        .filter((value: any) => value.message_type === msgType && value.direction === 'downlink');
      Vue.set(this, 'filteredFields', filtered);

      const fieldArray = [];
      for (const field of this.filteredFields) {
        const fieldValues = {
          field_name: field.fieldName,
          field_value: '',
          field_type: field.type,
          description: field.description,
        };
        fieldArray.push(fieldValues);
      }

      const msgs = [{
        message_type: msgType,
        configuration_profile_values: fieldArray,
      }];
      Vue.set(this.newProfile, 'configuration_profile_messages', msgs);

    }
  }

  private getConfigFromVue() {
    const profile = this.selectedProfile;
    const fields: any[] = [];
    if (typeof profile !== 'undefined' && typeof profile.configuration_profile_messages !== 'undefined') {
      for (const message of profile.configuration_profile_messages) {
        for (let entry of message.configuration_profile_values) {
          const schema = this.deviceType.schema_fields
                          .find((field: any) => entry.field_name === field.fieldName && message.message_type === field.message_type);

          const extendedSchema = { ...schema };
          entry = {
            field_name: entry.field_name,
            field_value: entry.field_value,
            field_type: entry.field_type,
            schema_field_id: extendedSchema.id,
            schema_field: extendedSchema,
          };
          fields.push(entry);
        }
      }
      const data = {
        id: profile.id,
        name: profile.name,
        device_version_id: profile.device_version_id,
        global_default: profile.global_default,
        configuration_profile_messages: [{
          message_type: profile.configuration_profile_messages[0].message_type,  // TODO: Allow multiple message types
          configuration_profile_values: fields,
        }],
      };

      this.validateConfig(data);
      return data;
    }
  }

  private validateConfig(output: any) {
    let isValid: boolean = false;
    output.name && output.device_version_id ? isValid = true : isValid = false;

    if (isValid) {
      this.configurationProfiles = this.configurationProfiles.filter((profile: any) => profile.id !== output.id);

      this.configurationProfiles.push(output);

      this.$emit('updateConfig', output, this.configurationProfiles);
      this.editing = false;
    }
  }

  // When close is clicked after adding profile
  private createProfile() {
    const allProfiles = this.configurationProfiles;

    const profile: any = {
      name: this.newProfile.name,
      device_version_id: this.deviceType.id,
      is_default: this.newProfile.global_default,
      configuration_profile_messages: [{
        message_type: this.selectedMessageType,
        configuration_profile_values: [],
      }],
    };
    for (const entry of this.newProfile.configuration_profile_messages[0].configuration_profile_values) { // TODO: Allow for multiple message types
      const schema = this.deviceType.schema_fields
            .find((field: any) => field.message_type === this.selectedMessageType && entry.field_name === field.fieldName);

      if (schema) {
        profile.configuration_profile_messages[0].configuration_profile_values.push({
          field_name: entry.field_name,
          field_value: entry.field_value,
          field_type: entry.field_type,
          description: entry.description,
          schema_field_id: schema.id,
        });
      } else {
        this.configError = `There is no schema data, you must create a new message type first.`;
      }
    }
    if (profile.name && profile.device_version_id) {
      this.addingProfile = false;
      this.isProfileView = true;
      allProfiles.push(profile);
      Vue.set(this, 'configurationProfiles', allProfiles);

      this.$emit('createProfile', profile, this.configurationProfiles);

      this.addingProfile = false;
      this.isProfileView = false;
      this.selectedProfileName = null;
      this.selectedMessageType = null;
    }
  }

  private deleteConfigurationProfile(selectedProfile: any) {
    const input = this.configurationProfiles;
    const filtered = input.filter((entry: any) => entry.id !== selectedProfile.id);

    Vue.set(this, 'configurationProfiles', filtered);
    this.$emit('deleteConfig', selectedProfile, this.configurationProfiles);

    this.addingProfile = false;
    this.isProfileView = false;
  }

  // When selecting profile from dropdown
  private selectProfile(event: any) {
    const input = this.configurationProfiles;
    this.configError = '';
    this.isProfileView = true;
    this.addingProfile = false;

    let selectedProfile: any = {};
    let msgType: string = '';

    if (typeof event === 'undefined') {
      if (input.length > 0) {
        Vue.set(this, 'selectedProfile', input[input.length - 1]);
        selectedProfile = this.selectedProfile;
        msgType = this.selectedProfile.configuration_profile_messages[0].message_type;
      } else {
        Vue.set(this, 'selectedProfile', {});
      }
    } else {
      const profileIndex = input.findIndex((i: any) => i.name === event);
      Vue.set(this, 'selectedProfile', input[profileIndex]);
      Vue.set(this, 'selectedProfileName', this.selectedProfile.name);

      selectedProfile = this.selectedProfile;
      msgType = this.selectedProfile.configuration_profile_messages[0].message_type;
    }
    this.filterForMessageType(msgType); // TODO: Allow for multiple messages

    for (const message of selectedProfile.configuration_profile_messages) {
      for (const entry of message.configuration_profile_values) {
        if (entry.schema_field) {
          if (!entry.field_type) {
            entry.field_type = entry.schema_field.type;
          }
          if (!entry.description) {
            const field = this.filteredFields.find((f: any) => {
              if (f.message_type === entry.schema_field.message_type && f.fieldName === entry.schema_field.fieldName) { return f; }
            });
            if (field) {
              entry.description = field.description;
            }
          }
        }
      }
    }
    Vue.set(this, 'selectedProfile', selectedProfile);
  }

  private addConfigurationFields(msgType: any) {
    const selectedProfile = this.selectedProfile;
    const newProfile = this.newProfile;
    let newValues: any = {};

    if (!this.addingProfile) {
      newValues = {
        configuration_profile_id: selectedProfile.id,
        configuration_profile_message_id: selectedProfile.configuration_profile_messages[0].configuration_profile_values[0].configuration_profile_message_id, // Message id will be the same in one profile
        field_name: '',
        field_value: '',
        field_type: '',
        schema_field: {
          fieldName: '',
          message_type: selectedProfile.configuration_profile_messages[0].message_type,
          type: '',
        },
      };

      newValues.field_name = newValues.schema_field.fieldName;
      selectedProfile.configuration_profile_messages[0].configuration_profile_values.push(newValues);
    } else {
      newValues = {
        field_value: '',
        field_type: '',
        schema_field: {
          fieldName: '',
          message_type: msgType,
          type: '',
        },
      };
      newProfile.configuration_profile_messages[0].configuration_profile_values.push(newValues);
    }
    Vue.set(this, 'selectedProfile', selectedProfile);
    Vue.set(this, 'newProfile', newProfile);
  }

  private async removeConfigurationFields(i: number, j: number) {
    let profileFields: any = {};
    let profile: any = {};

    if (!this.addingProfile) {
      profile = this.selectedProfile;
      profileFields = this.selectedProfile.configuration_profile_messages[i];
    } else {
      profile = this.newProfile;
      profileFields = this.newProfile.configuration_profile_messages[i];
    }
    const filtered = profileFields.configuration_profile_values.filter((field: any, index: number) => {
      return index !== j;
    });
    profileFields.configuration_profile_values.map((entry: any) => {
      if (typeof entry.id === 'undefined') { entry.id = 1; }
      if (entry.id !== profile.id) {
        Vue.set(profileFields, 'configuration_profile_values', filtered);

        !this.addingProfile ?
          Vue.set(this.selectedProfile.configuration_profile_messages, i, profileFields) :
          Vue.set(this.newProfile.configuration_profile_messages, i, profileFields);
      }
    });
  }

  private typeLookup(name: string, j: number, i: number) {
    let profile: any = {};
    if (!this.addingProfile) {
      profile = this.selectedProfile;
    } else {
      profile = this.newProfile;
    }

    if (i >= 0) {
      this.filteredFields.find((field: any) => {
        if (field.fieldName === name) {
          if (!this.addingProfile) {
            profile.configuration_profile_messages[i].configuration_profile_values[j].field_type = field.type;
            profile.configuration_profile_messages[i].configuration_profile_values[j].description = field.description;
          } else {
            profile.configuration_profile_messages[0].configuration_profile_values[j].field_type = field.type;
            profile.configuration_profile_messages[0].configuration_profile_values[j].description = field.description;
          } // TODO: Allow multiple messages
        }
        !this.addingProfile ?
          Vue.set(this, 'selectedProfile', profile) :
          Vue.set(this, 'newProfile', profile);
      });
    }
  }
}
